export const DashboardPbhExcelHeader = [
  {
    header: "REF NO",
    key: "REF NO",
    width: 25,
  },
  {
    header: "CUSTOMER NAME",
    key: "CUSTOMER NAME",
  },
  {
    header: "CUSTOMER PO",
    key: "CUSTOMER PO",
  },
  {
    header: "REQUIREMENT CATEGORY",
    key: "REQUIREMENT CATEGORY",
  },
  {
    header: "PN",
    key: "PN",
  },
  {
    header: "PN DESCRIPTION",
    key: "PN DESCRIPTION",
  },
  {
    header: "IS POOL SCOPE",
    key: "IS POOL SCOPE",
    isCustomer: false,
  },
  {
    header: "DESTINATION",
    key: "DESTINATION",
  },
  {
    header: "AC",
    key: "AC",
  },
  {
    header: "REQUEST DATE",
    key: "REQUEST DATE",
  },
  {
    header: "REQUESTED DELIVERY DATE",
    key: "REQUESTED DELIVERY DATE",
  },
  {
    header: "STATUS",
    key: "STATUS",
  },
  {
    header: "ALTERNATE PN STATUS",
    key: "ALTERNATE PN STATUS",
  },
  {
    header: "SERVICEABLE",
    key: "SERVICEABLE",
  },
  {
    header: "CORE UNIT",
    key: "CORE UNIT",
  },
  {
    header: "PBH NOTE",
    key: "PBH NOTE",
    isCustomer: false,
  },
  // {
  //     header: 'TIMEZONE',
  //     key: 'TIMEZONE'
  // },
];

export const DashboardPbhExcelName = "Request Dashboard List";
